import { GlobalAxios } from "../axios/axios-config";
import {
  ITicketDefaultDocCategories,
  ITicketDefaultDocCategory,
} from "../models/ticket-default-doc-category";

const TICKET_DEFAULT_DOC_CATEGORY_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketDefaultDocCategory/";

export const createTicketDefaultDocCategory = (
  item: ITicketDefaultDocCategory
) => {
  return GlobalAxios.post(TICKET_DEFAULT_DOC_CATEGORY_ROUTE, item);
};

export const getTicketDefaultDocCategoryById = (id: string) => {
  return GlobalAxios.get<ITicketDefaultDocCategories>(
    TICKET_DEFAULT_DOC_CATEGORY_ROUTE + id
  );
};

export const updateTicketDefaultDocCategoryById = ({
  item,
  id,
}: {
  item: ITicketDefaultDocCategory;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_DEFAULT_DOC_CATEGORY_ROUTE + id, item);
};

export const listTicketDefaultDocCategories = (params?: any) => {
  return GlobalAxios.get<ITicketDefaultDocCategories[]>(
    TICKET_DEFAULT_DOC_CATEGORY_ROUTE + "list",
    {
      params: params,
    }
  );
};

export const listProfileAccessTicketDefaultDocCategories = (params?: any) => {
  return GlobalAxios.get<ITicketDefaultDocCategories[]>(
    TICKET_DEFAULT_DOC_CATEGORY_ROUTE + "list/profile-access",
    {
      params: params,
    }
  );
};
